import { render, staticRenderFns } from "./SyncParseErrorsModal.vue?vue&type=template&id=133de7a6&scoped=true"
import script from "./SyncParseErrorsModal.vue?vue&type=script&lang=js"
export * from "./SyncParseErrorsModal.vue?vue&type=script&lang=js"
import style0 from "./SyncParseErrorsModal.vue?vue&type=style&index=0&id=133de7a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133de7a6",
  null
  
)

export default component.exports